import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GenericHeader from "@/app/core/layouts/main/components/GenericHeader";
import { useEffect } from "react";
import LegalPersonRegister from "./components/LegalPersonRegister";


export default function SignIn(props) {
  const [authenticate, setAuthenticate] = useState(false);
  const [companyId, setCompanyId] = useState(null);
  const [route, setRoute] = useState(0);

  useEffect(() => {
    loadPresentation()
  }, [])

  function loadPresentation() {
    let param = props.location.search;
    let returnBool = false;
    if (param !== undefined) {
      let item = param.split("?")[1];
      if (item !== undefined) {
        if (item.includes("companyId")) {
          setCompanyId(item.split("companyId=")[1])
          returnBool = true;
        }
      }
    }
  }

  if (authenticate) return <Redirect to="/app" />;
  return (
    <div id="page-container">
      <main id="main-container">
        <div className="bg-image">
          <GenericHeader register={false} />
          <div className="row no-gutters bg-black-25">
            <div className="hero-static col-md-6 d-flex align-items-center bg-white">
              <div className="p-3 w-100">

                <div className="row no-gutters justify-content-center">
                  <LegalPersonRegister goBack={() => setRoute(0)} companyId={companyId} />
                </div>
              </div>
            </div>

            <div className="hero-static col-md-6 d-none d-md-flex align-items-md-center justify-content-md-center text-md-center bg-white"
              style={{
                height: "100%",
                backgroundImage: "url('assets/media/photos/BG-login.png')",
                BackgroundPosition: "bottom"
              }}>
              <div className="p-3">
                <p className="display-4 font-w700 text-white mb-3">
                  {/* Colocar um texto legal */}
                </p>
                <p className="font-size-lg font-w600 text-white-75 mb-0">
                  Copyright <b>BeeMove</b> &copy;{" "}
                  <span className="js-year-copy">
                    {new Date().getFullYear()}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer />
    </div>
  );
}
